// base
import { createSlice } from '@reduxjs/toolkit';
import { QNA_SLICE_NAME } from '../actions/qna.action';
import {
  getQnaList,
  getQnaDetail,
  postQna,
  getUpdateQna,
  deleteQna,
  getQnaPic,
  getQnaComment,
  getQnaCommentModify,
  getQnaCommentDelete
} from '../thunks/qna.thunk';

const initialState = {
  qnaInfo: undefined,
  qna: [],
  totalMap: undefined,
  comment: undefined
};

const qnaSlice = createSlice({
  name: QNA_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQnaList.fulfilled, (state, action) => {
        const { resultList, totalMap } = action.payload;
        state.qna = resultList || [];
        state.totalMap = totalMap;
      })

      .addCase(getQnaDetail.fulfilled, (state, action) => {
        const res = action.payload;
        state.qnaInfo = res.resultObject;
      })

      .addCase(postQna.fulfilled, (state, action) => {
        const res = action.payload;
        state.qnaInfo = res.resultObject;
      })

      .addCase(postQna.rejected, (state, action) => {
        const res = action.payload;
        state.qnaInfo = res.resultList || [];
      })

      .addCase(getUpdateQna.fulfilled, (state, action) => {
        const res = action.payload;
        state.qnaInfo = res;
      })
      .addCase(deleteQna.fulfilled, (state, action) => {
        const res = action.payload;
        state.qnaInfo = { ...res };
      })
      .addCase(getQnaPic.fulfilled, (state, action) => {
        const res = action.payload;
        state.qnaInfo = { res };
      })

      .addCase(getQnaComment.fulfilled, (state, action) => {
        const res = action.payload;
        state.comment = res.resultObject;
      })

      .addCase(getQnaCommentModify.fulfilled, (state, action) => {
        const res = action.payload;
        state.comment = res.resultObject;
      })

      .addCase(getQnaCommentDelete.fulfilled, (state, action) => {
        const res = action.payload;
        state.comment = res.resultObject;
      });
  }
});

export const qna = qnaSlice.name;
export const qnaReducer = qnaSlice.reducer;
export const qnaAction = qnaSlice.actions;
export default qnaSlice.reducer;
